<template>
    <div
        class="content-box"
        :class="{
            [$style.wrapper]: true,
            [$style.error]: false,
            [$style.empty]: items.length === 0,
        }"
    >
        <div :class="$style.addItem">
            <input
                v-model.trim="newItem"
                style="width: auto"
                type="text"
                class="form-control form-control-sm"
                @keypress.enter="addItem"
                @blur="addItem"
            />
            <button type="button" class="btn btn-default" @click="addItem">
                Add
            </button>
        </div>
        <div v-if="items.length" :class="$style.items">
            <multi-input-item
                v-for="(item, index) in items"
                :id="index"
                :key="index"
                :text="item"
                @delete="onDeleteItem"
                @update="onUpdateItem"
            />
        </div>
    </div>
</template>

<script>
import InteractsWithDataModel from './InteractsWithDataModel.vue';
import MultiInputItem from './MultiInputItem';
import { Toast, isJson } from 'larasnap/support';

export default {
    components: {
        MultiInputItem,
    },
    mixins: [InteractsWithDataModel],
    props: {
        field: String,
    },
    data() {
        return {
            newItem: '',
            items: isJson(this.startValue) ? JSON.parse(this.startValue) : '',
        };
    },
    computed: {
        newItemIsDuplicate() {
            return this.items.includes(this.newItem);
        },
    },
    mounted() {
        if (this.items === '') {
            this.items = [];
        }
    },
    methods: {
        addItem(e) {
            e.preventDefault();

            if (this.newItemIsDuplicate) {
                Toast.error('You cannot add duplicate items');
                return;
            }

            if (this.newItem !== '') {
                this.items.push(this.newItem);
                this.newItem = '';
            }
        },
        onDeleteItem(id) {
            this.items.splice(id, 1);
        },
        onUpdateItem(id, text) {
            this.items.splice(id, 1, text);
        },
    },
};
</script>

<style lang="scss" module>
.wrapper {
    width: 300px;
    padding: 0;

    &.empty {
        .addItem {
            button {
                border-bottom-right-radius: 3.2px;
            }
        }
    }
    &:not(.empty) {
        .addItem {
            border-bottom: var(--grayBorder);

            button {
                border-bottom-right-radius: 0;
            }
        }
    }
}
.addItem {
    display: grid;
    grid-gap: 0;
    grid-template-columns: [col] auto [col] 50px;
    grid-template-rows: [row] auto;

    button {
        line-height: 1em;
        border-top-left-radius: 0;
        border-top-right-radius: 3.2px;
        border-bottom-left-radius: 0;
        border: 0;
    }
    input {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        border: 0;
        border-right: var(--grayBorder);
    }
}
.items {
    @extend %customScrollbar1;

    padding: 5px;
    line-height: 1.1;
    max-height: 100px;
    overflow: auto;
}
</style>
